import styled from 'styled-components'
import { Select } from 'antd'

export const StyledSelect = styled(Select)`
  width: 100%;
`
